import PocketBase from 'pocketbase';

/**
 * PocketBase is reached same-origin under `/pb` (Caddy routes `/pb/*` to the PB
 * container). Realtime subscriptions for devices/submissions attach in f3/f7.
 */
export const pb = new PocketBase('/pb');
pb.autoCancellation(false);
